<template>
  <div id="app">
    <HeaderStyles1/>
    <router-view/>
    <PageFooter />
  </div>
</template>

<script>
import PageFooter from './components/PageFooter'
import HeaderStyles1 from './components/HeaderStyles1'

export default {
  components: {
    HeaderStyles1,
    PageFooter
  },
  mounted () {
    document.title = 'Compathnion | Smart Solution for Location Service'
  }
}
</script>
